module.exports = __webpack_public_path__ + "img/homepage.30080088.jpg";